module.exports = __webpack_public_path__ + "img/founders_10.f67c492c.jpg";